import React from 'react'
import { Badge } from '../common/Badge/Badge'
import { ITicket } from '../../interfaces/models/ticket.interfaces'
import { useAppTranslation } from '../../hooks/useAppTranslation'

export const TicketBadge = ({
  status,
}: {
  status: ITicket['status']
}): React.ReactNode => {
  const { translate } = useAppTranslation()
  return (
    <Badge
      padding="px-1.5"
      colorClass={status === 'closed' ? 'bg-rose-200' : 'bg-brandGreen/10'}
      borderColorClass={
        status === 'closed' ? 'border-red' : 'border-brandGreen'
      }
      textColorClass="text-black"
      text={translate(`ticket.status.${status}`)}
      className="h-5 w-fit"
    />
  )
}
